import { useMutation, useQueryClient } from "@tanstack/react-query";

import { showErrorToast, showSuccessToast } from "#app/notifications";
import { productsQuery } from "#modules/products/infra/products.query";
import { uploadCustomProducts } from "#modules/products/infra/uploadCustomProducts.api";

export const useUploadCustomProducts = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: uploadCustomProducts,
    onSuccess: () => {
      showSuccessToast({ title: "Fichier téléchargé" });
      void queryClient.invalidateQueries(productsQuery());
    },
    onError: () => {
      showErrorToast({ title: "Erreur lors du chargement du fichier" });
    },
  });

  return { uploadCustomProducts: mutate, ...rest };
};
